
import { Component, Emit, Vue } from 'vue-property-decorator';
import { Color, colorClass } from '../model/colors';

@Component
export default class Palette extends Vue {

  private colors = [...Array(16).keys()];

  private selected = {
    color: 1,
  };

  private colorClass = colorClass;

  @Emit('color')
  public colorSelected(color: Color): Color {
    this.selected.color = color;
    return color;
  }

  protected mounted() {
    this.colorSelected(this.selected.color);
  }

  private isSelected(color: Color): boolean {
    return color === this.selected.color;
  }

}
